import { render, staticRenderFns } from "./LugarComentarios.vue?vue&type=template&id=3e3a7e47&scoped=true"
import script from "./LugarComentarios.vue?vue&type=script&lang=js"
export * from "./LugarComentarios.vue?vue&type=script&lang=js"
import style0 from "./LugarComentarios.vue?vue&type=style&index=0&id=3e3a7e47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3a7e47",
  null
  
)

export default component.exports